module.exports = __webpack_public_path__ + "img/km_20.38e7ba22.jpeg";